// Система pop-up tutorial для приложения

class Tutorial {
    constructor() {
        this.currentStep = 0;
        this.steps = [];
        this.overlay = null;
        this.popup = null;
        this.highlightedElement = null;
        this.isActive = false;
        this.completedTutorial = localStorage.getItem('tutorialCompleted') === 'true';
        this.overlayParts = [];
        this.centerControlsHideTimeout = null;
    }

    // Определяем шаги tutorial
    initSteps() {
        this.steps = [
            {
                title: 'Добро пожаловать!',
                content: 'Это приложение поможет тебе научиться играть на гитаре. Давай пройдем краткий обзор основных функций.',
                target: null,
                position: 'center'
            },
            {
                title: 'Блоки мелодии (едим слона по частям )))',
                content: 'Правильно, ты будешь играть песню частями, для начала пройди отдельные блоки.',
                target: '#melodyBlocks',
                position: 'bottom'
            },
            {
                title: 'Блоки мелодии (продолжаем есть слона )))',
                content: 'Блоки можно проходить в любой последовательности. С каждым уровнем скорость будет нарастать. Как только ты пройдёшь блок с точностью более 90%, ты попадёшь на новый уровень!',
                target: '.melody-block',
                position: 'bottom'
            },
            {
                title: 'Полная последовательность',
                content: 'Пройденные блоки будут подсвечиваться, здесь ты можешь увидеть свой прогресс в изучении песни',
                target: '#fullMelodySequence',
                position: 'bottom'
            },
            {
                title: 'Воспроизведение музыки',
                content: 'После того как ты отработаешь все блоки, сможешь сыграть всю песню целиком!',
                target: '#playAllBtn',
                position: 'bottom',
                action: () => {
                    // Показываем панель с кнопками, если она скрыта
                    const centerControls = document.querySelector('.top-bar-center-controls');
                    if (centerControls) {
                        const computedStyle = window.getComputedStyle(centerControls);
                        const isHidden = computedStyle.display === 'none';
                        
                        if (isHidden) {
                            centerControls.style.display = 'flex';
                            
                            // Очищаем предыдущий таймер, если есть
                            if (this.centerControlsHideTimeout) {
                                clearTimeout(this.centerControlsHideTimeout);
                            }
                            
                            // Устанавливаем таймер для автоматического скрытия через 5 секунд
                            this.centerControlsHideTimeout = setTimeout(() => {
                                centerControls.style.display = 'none';
                                this.centerControlsHideTimeout = null;
                            }, 5000);
                        }
                    }
                }
            },
            {
                title: 'Прослушать песню',
                content: 'Эта кнопка позволяет прослушать оригинальную композицию перед началом игры.',
                target: '#startPlayMusic',
                position: 'bottom'
            },
            {
                title: 'Настройки',
                content: 'Здесь ты можешь настроить свою гитару.',
                target: '#toggleTabBtn',
                position: 'bottom'
            },
            {
                title: 'Тюнер',
                content: 'Этот раздел поможет тебе для точного определения нот',
                target: '#stringButtonsContainer',
                position: 'top',
                action: () => {
                    // Переключаемся на вкладку настроек
                    const toggleBtn = document.getElementById('toggleTabBtn');
                    if (toggleBtn && toggleBtn.classList.contains('active')) {
                        toggleBtn.click();
                    }
                }
            },
            {
                title: 'Включение микрофона',
                content: 'Для работы тюнера и комфортной игры тебе нужно включить микрофон. Нажми кнопку "Включить микрофон" и "разрешить доступ в браузере".',
                target: '#micBtn',
                position: 'top',
                action: () => {
                    // Прокручиваем к кнопке, чтобы она была видна
                    const micBtn = document.querySelector('#micBtn');
                    if (micBtn) {
                        micBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }
            },
            {
                title: 'Готово!',
                content: 'Теперь ты знаешь основы работы с приложением. Удачи в обучении! Ты всегда можешь вернуться к обучалке в верхней панеле.',
                target: '#restartTutorialBtn',
                position: 'center'
            }
        ];
    }

    // Создаем overlay для затемнения фона
    createOverlay() {
        if (this.overlay) return;
        
        this.overlay = document.createElement('div');
        this.overlay.className = 'tutorial-overlay';
        this.overlay.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            z-index: 9998;
            transition: opacity 0.3s ease;
        `;
        document.body.appendChild(this.overlay);
    }

    // Создаем popup с информацией
    createPopup() {
        if (this.popup) return;
        
        this.popup = document.createElement('div');
        this.popup.className = 'tutorial-popup';
        this.popup.style.cssText = `
            position: fixed;
            background: linear-gradient(135deg, #1a2a6c, #2c3e50);
            border: 2px solid #4fc3f7;
            border-radius: 15px;
            padding: 25px;
            max-width: 400px;
            z-index: 9999;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
            color: #fff;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            transition: all 0.3s ease;
        `;
        document.body.appendChild(this.popup);
    }

    // Выделяем целевой элемент
    highlightElement(selector) {
        // Убираем предыдущее выделение
        if (this.highlightedElement) {
            this.highlightedElement.classList.remove('tutorial-highlighted');
        }

        if (!selector) {
            this.highlightedElement = null;
            this.updateOverlayClip(null);
            return;
        }

        const element = document.querySelector(selector);
        if (element) {
            this.highlightedElement = element;
            element.classList.add('tutorial-highlighted');
            
            // Прокручиваем к элементу если нужно
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            
            // Обновляем overlay чтобы создать отверстие вокруг элемента
            requestAnimationFrame(() => {
                this.updateOverlayClip(element);
            });
        } else {
            this.highlightedElement = null;
            this.updateOverlayClip(null);
        }
    }

    // Обновляем overlay чтобы создать отверстие вокруг выделенного элемента
    updateOverlayClip(element) {
        if (!this.overlay) return;

        // Удаляем старые части overlay
        if (this.overlayParts && this.overlayParts.length > 0) {
            this.overlayParts.forEach(part => {
                if (part && part.parentNode) {
                    part.parentNode.removeChild(part);
                }
            });
            this.overlayParts = [];
        }

        // Всегда затемняем весь фон
        this.overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        this.overlay.style.clipPath = 'none';

        if (!element) {
            // Нет выделенного элемента - затемняем весь экран
            return;
        }

        const rect = element.getBoundingClientRect();
        const padding = 8; // Отступ от края элемента для отверстия
        
        const left = Math.max(0, rect.left - padding);
        const top = Math.max(0, rect.top - padding);
        const right = Math.min(window.innerWidth, rect.right + padding);
        const bottom = Math.min(window.innerHeight, rect.bottom + padding);
        
        const viewWidth = window.innerWidth;
        const viewHeight = window.innerHeight;
        
        // Создаем 4 прямоугольника для затемнения вокруг элемента
        const parts = [
            // Верхний прямоугольник
            { top: 0, left: 0, width: viewWidth, height: top },
            // Нижний прямоугольник
            { top: bottom, left: 0, width: viewWidth, height: viewHeight - bottom },
            // Левый прямоугольник
            { top: top, left: 0, width: left, height: bottom - top },
            // Правый прямоугольник
            { top: top, left: right, width: viewWidth - right, height: bottom - top }
        ];

        this.overlayParts = [];
        parts.forEach(part => {
            if (part.width > 0 && part.height > 0) {
                const partDiv = document.createElement('div');
                partDiv.className = 'tutorial-overlay-part';
                partDiv.style.cssText = `
                    position: fixed;
                    top: ${part.top}px;
                    left: ${part.left}px;
                    width: ${part.width}px;
                    height: ${part.height}px;
                    background: rgba(0, 0, 0, 0.7);
                    z-index: 9998;
                    pointer-events: none;
                `;
                document.body.appendChild(partDiv);
                this.overlayParts.push(partDiv);
            }
        });

        // Делаем основной overlay прозрачным, так как затемнение теперь в отдельных частях
        this.overlay.style.backgroundColor = 'transparent';
    }

    // Позиционируем popup всегда по центру окна
    positionPopup(step) {
        if (!this.popup) return;

        const margin = 20; // Отступ от краев экрана

        // Для шага с #micBtn позиционируем popup выше, чтобы кнопка была видна
        if (step.target === '#micBtn') {
            this.popup.style.top = '25%';
            this.popup.style.left = '50%';
            this.popup.style.transform = 'translate(-50%, -50%)';
        } else {
            // Всегда центрируем popup для остальных шагов
            this.popup.style.top = '50%';
            this.popup.style.left = '50%';
            this.popup.style.transform = 'translate(-50%, -50%)';
        }

        // Устанавливаем максимальные размеры чтобы popup не выходил за границы
        this.popup.style.maxWidth = `${Math.min(400, window.innerWidth - margin * 2)}px`;
        this.popup.style.maxHeight = `${window.innerHeight - margin * 2}px`;
    }

    // Обновляем содержимое popup
    updatePopup(step) {
        if (!this.popup) return;

        const stepNumber = this.currentStep + 1;
        const totalSteps = this.steps.length;

        this.popup.innerHTML = `
            <div style="margin-bottom: 15px;">
                <h2 style="margin: 0 0 10px 0; color: #4fc3f7; font-size: 1.5em;">${step.title}</h2>
                <p style="margin: 0; line-height: 1.6; font-size: 1em;">${step.content}</p>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 20px; gap: 10px;">
                <div style="color: rgba(255, 255, 255, 0.6); font-size: 0.9em;">
                    ${stepNumber} / ${totalSteps}
                </div>
                <div style="display: flex; gap: 10px;">
                    ${this.currentStep > 0 ? `
                        <button id="tutorialPrevBtn" style="
                            padding: 8px 16px;
                            background: rgba(79, 195, 247, 0.2);
                            border: 1px solid #4fc3f7;
                            border-radius: 5px;
                            color: #4fc3f7;
                            cursor: pointer;
                            font-size: 0.9em;
                            transition: all 0.2s;
                        " onmouseover="this.style.background='rgba(79, 195, 247, 0.3)'" onmouseout="this.style.background='rgba(79, 195, 247, 0.2)'">
                            Назад
                        </button>
                    ` : ''}
                    <button id="tutorialNextBtn" style="
                        padding: 8px 16px;
                        background: #4fc3f7;
                        border: none;
                        border-radius: 5px;
                        color: #fff;
                        cursor: pointer;
                        font-size: 0.9em;
                        font-weight: bold;
                        transition: all 0.2s;
                    " onmouseover="this.style.background='#5dd3ff'" onmouseout="this.style.background='#4fc3f7'">
                        ${this.currentStep < this.steps.length - 1 ? 'Далее' : 'Завершить'}
                    </button>
                    ${this.currentStep < this.steps.length - 1 ? `
                    <button id="tutorialSkipBtn" style="
                        padding: 8px 16px;
                        background: transparent;
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        border-radius: 5px;
                        color: rgba(255, 255, 255, 0.7);
                        cursor: pointer;
                        font-size: 0.9em;
                        transition: all 0.2s;
                    " onmouseover="this.style.color='#fff'; this.style.borderColor='rgba(255, 255, 255, 0.5)'" onmouseout="this.style.color='rgba(255, 255, 255, 0.7)'; this.style.borderColor='rgba(255, 255, 255, 0.3)'">
                        Пропустить
                    </button>
                    ` : ''}
                </div>
            </div>
        `;

        // Добавляем обработчики событий
        const nextBtn = document.getElementById('tutorialNextBtn');
        const prevBtn = document.getElementById('tutorialPrevBtn');
        const skipBtn = document.getElementById('tutorialSkipBtn');

        if (nextBtn) {
            nextBtn.addEventListener('click', () => this.nextStep());
        }
        if (prevBtn) {
            prevBtn.addEventListener('click', () => this.prevStep());
        }
        if (skipBtn) {
            skipBtn.addEventListener('click', () => this.skip());
        }
    }

    // Переход к следующему шагу
    nextStep() {
        if (this.currentStep < this.steps.length - 1) {
            this.currentStep++;
            this.showStep(this.currentStep);
        } else {
            this.complete();
        }
    }

    // Переход к предыдущему шагу
    prevStep() {
        if (this.currentStep > 0) {
            this.currentStep--;
            this.showStep(this.currentStep);
        }
    }

    // Пропустить tutorial
    skip() {
        this.complete();
    }

    // Показать конкретный шаг
    showStep(stepIndex) {
        if (stepIndex < 0 || stepIndex >= this.steps.length) return;

        // Скрываем панель center-controls, если уходим с шага с #playAllBtn (индекс 4)
        if (this.currentStep === 4 && stepIndex !== 4) {
            // Очищаем таймер скрытия панели
            if (this.centerControlsHideTimeout) {
                clearTimeout(this.centerControlsHideTimeout);
                this.centerControlsHideTimeout = null;
            }
        }

        const step = this.steps[stepIndex];

        // Выполняем действие если есть
        if (step.action && typeof step.action === 'function') {
            step.action();
            // Даем время на выполнение действия
            setTimeout(() => {
                this.highlightElement(step.target);
                this.updatePopup(step);
                this.positionPopup(step);
            }, 300);
        } else {
            this.highlightElement(step.target);
            this.updatePopup(step);
            this.positionPopup(step);
        }
    }

    // Начать tutorial
    start() {
        if (this.isActive) return;
        
        this.isActive = true;
        this.currentStep = 0;
        this.initSteps();
        this.createOverlay();
        this.createPopup();
        this.showStep(0);

        // Обработчик изменения размера окна
        this.resizeHandler = () => {
            if (this.isActive && this.currentStep < this.steps.length) {
                this.positionPopup(this.steps[this.currentStep]);
                // Обновляем overlay при изменении размера окна
                if (this.highlightedElement) {
                    this.updateOverlayClip(this.highlightedElement);
                }
            }
        };
        window.addEventListener('resize', this.resizeHandler);
        
        // Обработчик прокрутки для обновления overlay
        this.scrollHandler = () => {
            if (this.isActive && this.highlightedElement) {
                this.updateOverlayClip(this.highlightedElement);
            }
        };
        window.addEventListener('scroll', this.scrollHandler, true);
    }

    // Завершить tutorial
    complete() {
        this.isActive = false;
        
        // Очищаем таймер скрытия панели
        if (this.centerControlsHideTimeout) {
            clearTimeout(this.centerControlsHideTimeout);
            this.centerControlsHideTimeout = null;
        }
        
        // Убираем выделение
        if (this.highlightedElement) {
            this.highlightedElement.classList.remove('tutorial-highlighted');
            this.highlightedElement = null;
        }

        // Удаляем элементы
        if (this.popup) {
            this.popup.style.opacity = '0';
            setTimeout(() => {
                if (this.popup && this.popup.parentNode) {
                    this.popup.parentNode.removeChild(this.popup);
                }
                this.popup = null;
            }, 300);
        }

        // Удаляем части overlay
        if (this.overlayParts && this.overlayParts.length > 0) {
            this.overlayParts.forEach(part => {
                if (part && part.parentNode) {
                    part.parentNode.removeChild(part);
                }
            });
            this.overlayParts = [];
        }

        if (this.overlay) {
            this.overlay.style.opacity = '0';
            setTimeout(() => {
                if (this.overlay && this.overlay.parentNode) {
                    this.overlay.parentNode.removeChild(this.overlay);
                }
                this.overlay = null;
            }, 300);
        }

        // Удаляем обработчики событий
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
            this.resizeHandler = null;
        }
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler, true);
            this.scrollHandler = null;
        }

        // Возвращаем пользователя на вкладку с игрой после завершения обучения
        if (window.app && typeof window.app.switchTab === 'function') {
            window.app.switchTab('guitar');
        }

        // Сохраняем, что tutorial завершен
        localStorage.setItem('tutorialCompleted', 'true');
        this.completedTutorial = true;
    }

    // Проверить, нужно ли показать tutorial
    shouldShowTutorial() {
        return !this.completedTutorial;
    }

    // Сбросить статус tutorial
    reset() {
        localStorage.removeItem('tutorialCompleted');
        this.completedTutorial = false;
    }
}

// Экспортируем singleton
export const tutorial = new Tutorial();
